"use client";
import { useState } from "react";

import { physicianDetailsSchema, physicianDetailsType } from "@/src/mocks";
import { reduceTypeToObj } from "@/src/utils/generic-utils";
import { FormProps } from "./form-one";
import FormContainer from "./form-container";
import { DashboardBaseButton, FloatingLabelInput } from "@/src/components";
import { toast } from "react-toastify";
import { useRouter } from "next/navigation";
import { setUpParentProfile } from "@/src/services";

const physicianDetailsLabel = [
  "Name of physician",
  "Physician address",
  "Name of last consulted clinic",
  "Address of last consulted clinic",
  "Reason for last consultation",
  "Date of last consultation",
  "What treatment was given",
];

const physicianDetailsLabelMap = reduceTypeToObj<physicianDetailsType>(
  physicianDetailsLabel,
  physicianDetailsSchema.describe().fields
);

function FormFive({ trigger, getValues, register, errors }: FormProps) {
  const values = getValues();
  const router = useRouter();
  const dotNotLabel = Object.keys(physicianDetailsSchema.describe().fields).map(
    (el) => el
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      await physicianDetailsSchema.validate(values, { abortEarly: false });

      await setUpParentProfile(values);
      toast.success("Parent's profile setup successfully", {
        autoClose: 2500,
        onClose: () => router.push("/profile/success"),
      });
      sessionStorage.removeItem("parent-profile");
      setIsLoading(false);
    } catch (error: any) {
      // @ts-ignore
      trigger(dotNotLabel);
      console.error(error.message);
      toast.warning(error?.result?.message || error?.response?.data?.message);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section>
      <FormContainer
        title="Finally at the finishing line"
        subTitle="Please fill below to complete your application."
      >
        <form>
          <div className="my-6">
            <div className="mb-5">
              <FloatingLabelInput
                label={physicianDetailsLabelMap.physician_name}
                id="physicianDetails.phyName"
                placeholder={physicianDetailsLabelMap.physician_name}
                {...register("physician_name")}
                error={errors?.physician_name?.message}
              />
            </div>

            <div className="mb-5">
              <FloatingLabelInput
                label={physicianDetailsLabelMap.physician_address}
                id="physicianDetails.phyAddress"
                placeholder={physicianDetailsLabelMap.physician_address}
                {...register("physician_address")}
                error={errors?.physician_address?.message}
              />
            </div>

            <div className="mb-5">
              <FloatingLabelInput
                label={physicianDetailsLabelMap.nameOfLastConsultedClinic}
                id="physicianDetails.phyClinicName"
                placeholder={physicianDetailsLabelMap.nameOfLastConsultedClinic}
                {...register("nameOfLastConsultedClinic")}
                error={errors?.nameOfLastConsultedClinic?.message}
              />
            </div>

            <div className="mb-5">
              <FloatingLabelInput
                label={physicianDetailsLabelMap.addressOfLastConsultedClinic}
                id="physicianDetails.phyClinicAddress"
                placeholder={
                  physicianDetailsLabelMap.addressOfLastConsultedClinic
                }
                {...register("addressOfLastConsultedClinic")}
                error={errors?.addressOfLastConsultedClinic?.message}
              />
            </div>
            <div className="mb-5">
              <FloatingLabelInput
                label={physicianDetailsLabelMap.reasonForLastConsultation}
                id="physicianDetails.lastConsultReason"
                placeholder={physicianDetailsLabelMap.reasonForLastConsultation}
                {...register("reasonForLastConsultation")}
                error={errors?.reasonForLastConsultation?.message}
              />
            </div>
            <div className="mb-5">
              <FloatingLabelInput
                label={physicianDetailsLabelMap.dateOfLastConsultation}
                id="physicianDetails.dateOfLastConsult"
                placeholder={physicianDetailsLabelMap.dateOfLastConsultation}
                type="date"
                {...register("dateOfLastConsultation")}
                error={errors?.dateOfLastConsultation?.message}
              />
            </div>
            <div className="mb-5">
              <FloatingLabelInput
                label={physicianDetailsLabelMap.treatmentGiven}
                id="physicianDetails.treatmentRecieved"
                placeholder={physicianDetailsLabelMap.treatmentGiven}
                {...register("treatmentGiven")}
                error={errors?.treatmentGiven?.message}
              />
            </div>
          </div>

          <div className="my-6">
            <DashboardBaseButton
              loading={isLoading}
              onClick={handleSubmit}
              fullWidth
            >
              Submit
            </DashboardBaseButton>
          </div>
        </form>
      </FormContainer>
    </section>
  );
}

export default FormFive;
